"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createComponentLoader = void 0;
var RegistryError_1 = require("../errors/RegistryError");
var loadAssets_1 = require("./loadAssets");
var loadBundle_1 = require("./loadBundle");
function createComponentLoader(_a) {
    var _this = this;
    var transport = _a.transport, component = _a.component, shouldLoadCSSAssets = _a.shouldLoadCSSAssets, environmentLoader = _a.environmentLoader;
    var loader = function (part) { return __awaiter(_this, void 0, void 0, function () {
        var url, id, components, model, error;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (part && !Object.keys(component.parts).length) {
                        throw RegistryError_1.createException('Loading component part is not available. It is only possible to load the whole component', RegistryError_1.RegistryErrorCode.IncorrectLoaderArguments).withComponent(component.name);
                    }
                    if (part) {
                        url = (_a = component.parts[part]) === null || _a === void 0 ? void 0 : _a.url;
                        id = (_b = component.parts[part]) === null || _b === void 0 ? void 0 : _b.id;
                    }
                    else {
                        url = component.url;
                        id = component.id;
                    }
                    if (!url || !id) {
                        throw RegistryError_1.createException('It is not possible load the component', RegistryError_1.RegistryErrorCode.IncorrectLoaderArguments).withComponent(component.name, part, Object.keys(component.parts));
                    }
                    return [4 /*yield*/, loadBundle_1.loadBundleComponents(transport, id, url, environmentLoader)];
                case 1:
                    components = (_c.sent()).components;
                    model = components[component.name];
                    if (Object.keys(components).length > 1) {
                        error = RegistryError_1.createException('Incorrect bundle. Bundle contains more than 1 component', RegistryError_1.RegistryErrorCode.IncorrectBundleExport)
                            .withComponent(component.name, part)
                            .withUrl(url)
                            .withHint('Probably library was bundled in a wrong way');
                        console.error(error.message);
                    }
                    if (!model) {
                        throw RegistryError_1.createException('Incorrect bundle. Component model does not exist', RegistryError_1.RegistryErrorCode.IncorrectBundleExport)
                            .withComponent(component.name, part)
                            .withUrl(url)
                            .withHint('Probably library was bundled in a wrong way');
                    }
                    if (model === 1) {
                        throw RegistryError_1.createException('Incorrect bundle. Wrong component model', RegistryError_1.RegistryErrorCode.IncorrectBundleExport)
                            .withComponent(component.name, part)
                            .withUrl(url)
                            .withHint("Probably library's webpack runtime was not loaded");
                    }
                    if (shouldLoadCSSAssets) {
                        loadAssets_1.loadAssets(component.assets);
                    }
                    // @ts-ignore
                    return [2 /*return*/, part ? model[part] : model];
            }
        });
    }); };
    loader.isPartExist = function (part) {
        return component.parts.hasOwnProperty(part);
    };
    loader.assets = component.assets;
    // loader.info = {};
    return loader;
}
exports.createComponentLoader = createComponentLoader;
//# sourceMappingURL=createComponentLoader.js.map